import { combineReducers } from '@reduxjs/toolkit'

import pageSlice from './page/pageSlice'
import routesSlice from './routes/routesSlice'
import propertiesSlice from './properties/propertiesSlice'
import resourcesSlice from './resources/resourcesSlice'
import wishlistSlice from './wishlist/wishlistSlice'
import cartSlice from './cart/cartSlice'
import compareProductsSlice from './comparelist/compareProductsSlice'

export default combineReducers({
	properties: propertiesSlice,
	currentPage: pageSlice,
	resources: resourcesSlice,
	routes: routesSlice,
	compareProducts: compareProductsSlice,
	wishlist: wishlistSlice,
	cart: cartSlice,
})
